export default {
  SET_PARENTS(state, payload) {
    state.parents = payload || []
  },
  RESET_PARENTS(state, payload) {
    state.parents = []
  },
  SET_ACTIVE_GROUP(state, payload) {
    state.activeGroup = payload || ''
  },
  SET_GROUPS(state, payload) {
    if (payload && payload.data) {
      payload.data.forEach(g => {
        g.userCount = g.activeMembers.length + g.inactiveMembers.length
      })
    }
    state.groups = payload || {}
  }
}



// WEBPACK FOOTER //
// ./src/app/store/groups/mutations.js